import React from "react";
import GoogleMap from 'google-map-react';
import MapPoint from "./MapPoint";

function Map(){
  const defaultProps = {
    center: {
      lat: 50.8223,
      lng: 6.45808
    },
    zoom: 13,
    
  };

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: '100%', width: '100%' }}>
      <GoogleMap
        bootstrapURLKeys={{ key: "AIzaSyAR8YBi8LhTI4tHF2Ua5J7LwUiQVZTceUk" }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        gestureHandling="none"
      >
         <MapPoint
          lat={50.8223}
          lng={6.45808}
        />
      </GoogleMap>
    </div>
  );
}

export default Map;